(function () {
    'use strict';

    angular.module('app').factory('BriefService', BriefService);

    function BriefService(WebApiService) {
        return {
            createBriefSeasonal: function (model, ignoreLoadingBar) {
                const config = {
                    ignoreLoadingBar: ignoreLoadingBar === true
                };
                return WebApiService.postJson('/api/brief/CreateBriefSeasonal', model, config);
            },

            deleteBriefSeasonal: function (briefSeasonalId) {
                const jsonBody = {
                    BriefSeasonalId: briefSeasonalId
                };
                return WebApiService.postJson('/api/brief/DeleteBrief', jsonBody);
            },

            getBriefCreateDetails: function (briefSeasonalId) {
                return WebApiService.get('/api/brief/create/' + briefSeasonalId);
            },

            getBriefEditDetails: function (briefSeasonalId) {
                return WebApiService.get('/api/brief/edit/' + briefSeasonalId);
            },

            getBriefEditLists: function () {
                return WebApiService.get('/api/brief/editPageLists');
            },

            getBriefLinePlans: function (briefSeasonalId) {
                return WebApiService.get('/api/brief/BriefLinePlans', {
                    BriefSeasonalId: briefSeasonalId
                });
            },

            getBriefPatternsFactoryFiltered: function (briefSeasonalId) {
                return WebApiService.get(
                    '/api/brief/BriefPatternsFactoryFiltered',
                    {
                        BriefSeasonalId: briefSeasonalId
                    },
                    {
                        ignoreLoadingBar: true
                    }
                );
            },

            getBriefPatterns: function (briefSeasonalId) {
                return WebApiService.get(
                    '/api/brief/BriefPatterns',
                    {
                        BriefSeasonalId: briefSeasonalId
                    },
                    {
                        ignoreLoadingBar: true
                    }
                );
            },

            getBriefPatternsCount: function (briefSeasonalId) {
                return WebApiService.get(
                    '/api/brief/BriefPatternsCount',
                    {
                        BriefSeasonalId: briefSeasonalId
                    },
                    {
                        ignoreLoadingBar: true
                    }
                );
            },

            getBriefsByBrandSeason: function (brandId, seasonId) {
                const queryString = {
                    BrandId: brandId,
                    SeasonId: seasonId
                };
                return WebApiService.get('/api/brief/BriefsByBrandSeason', queryString);
            },

            getBriefSeasonalList: function () {
                return WebApiService.get('/api/brief/BriefSeasonalList');
            },

            getBriefStatuses: function (brandId, seasonId, filterUser, ignoreLoader) {
                const queryString = {
                    BrandId: brandId,
                    SeasonId: seasonId,
                    FilterUser: filterUser
                };
                const config = {};

                if (typeof ignoreLoader !== 'undefined') {
                    config.ignoreLoadingBar = ignoreLoader;
                }

                return WebApiService.get('/api/brief/GetBriefStatuses', queryString, config);
            },

            getBriefViewDetails: function (briefSeasonalId) {
                return WebApiService.get('/api/brief/view/' + briefSeasonalId);
            },

            getRelinkList: function (patternSeasonalId) {
                const queryString = {
                    patternSeasonalId: patternSeasonalId
                };
                return WebApiService.get('/api/brief/RelinkList', queryString);
            },

            isBriefNameExists: function (briefId, briefName, brandId, seasonId) {
                const queryString = {
                    BriefId: briefId,
                    BriefName: briefName,
                    BrandId: brandId,
                    SeasonId: seasonId
                };
                return WebApiService.get('/api/brief/IsBriefNameExists', queryString);
            },

            relinkBrief: function (briefId, lineplanId) {
                const jsonBody = {
                    BriefId: briefId,
                    LinePlanId: lineplanId
                };
                return WebApiService.postJson('/api/brief/RelinkBrief', jsonBody);
            },

            searchBriefs: function (searchObject, pageNumber, pageSize, sortColumn, sortDirection) {
                searchObject.pageNumber = pageNumber;
                searchObject.pageSize = pageSize;
                searchObject.sortColumn = sortColumn;
                searchObject.sortDirection = sortDirection;
                return WebApiService.postJson('/api/brief/SearchBriefs', searchObject);
            },

            exportBriefs: function(searchObject, pageNumber, pageSize, sortColumn, sortDirection) {
                searchObject.pageNumber = pageNumber;
                searchObject.pageSize = pageSize;
                searchObject.sortColumn = sortColumn;
                searchObject.sortDirection = sortDirection;

                return WebApiService.postJson("/api/brief/ExportBriefs", searchObject);
            },

            updateBrief: function (briefData) {
                return WebApiService.postJson('/api/brief/UpdateBrief', briefData);
            },

            ensureReleased: function (briefSeasonalId) {
                return WebApiService.postJson('/api/brief/EnsureReleased?briefSeasonalId=' + briefSeasonalId);
            },

            uploadMassBriefDocument: function (file) {
                return WebApiService.postFile("/api/brief/UploadBriefs", file);
            }
        };
    }
})();
